import React, { ReactNode } from "react";
import mediaQueries from "~/components/mediaQueries";

interface IChangePlanOptionDescriptionProps {
  description: ReactNode;
}

export default function ChangePlanOptionDescription({ description }: IChangePlanOptionDescriptionProps) {
  return (
    <div
      css={mediaQueries({
        display: "flex",
        alignItems: "center",
        height: "100%",
        padding: 20,
        textAlign: ["center", "center", "center", "left"],
        borderRight: ["none", "none", "none", "solid 1px #e3e3e3"],
        borderBottom: ["solid 1px #e3e3e3", "solid 1px #e3e3e3", "solid 1px #e3e3e3", "none"],
      })}
    >
      <p
        css={{
          margin: 0,
          fontSize: 14,
          lineHeight: 1.33,
          color: "#797979",
        }}
      >
        {description}
      </p>
    </div>
  );
}
